import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Awards from "@/pages/Awards";
import ClinicalExpertise from "@/pages/ClinicalExpertise";
import ClinicalDetail from "@/pages/ClinicalDetail";
import Research from "@/pages/Research";
import Impact from "@/pages/Impact";
import Education from "@/pages/Education";
import Media from "@/pages/Media";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import { Consultation, SecondOpinion } from "@/pages/Enquiries";
import { Collaborate, GetInvolved } from "@/pages/Involve";
import Support from "@/pages/Support";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

const Public = (C) => <Layout>{C}</Layout>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={Public(<Home />)} />
            <Route path="/about" element={Public(<About />)} />
            <Route path="/awards" element={Public(<Awards />)} />
            <Route path="/clinical-expertise" element={Public(<ClinicalExpertise />)} />
            <Route path="/clinical-expertise/:slug" element={Public(<ClinicalDetail />)} />
            <Route path="/research" element={Public(<Research />)} />
            <Route path="/impact" element={Public(<Impact />)} />
            <Route path="/education" element={Public(<Education />)} />
            <Route path="/media" element={Public(<Media />)} />
            <Route path="/insights" element={Public(<Insights />)} />
            <Route path="/insights/:slug" element={Public(<InsightDetail />)} />
            <Route path="/gallery" element={Public(<Gallery />)} />
            <Route path="/contact" element={Public(<Contact />)} />
            <Route path="/consultation" element={Public(<Consultation />)} />
            <Route path="/second-opinion" element={Public(<SecondOpinion />)} />
            <Route path="/collaborate" element={Public(<Collaborate />)} />
            <Route path="/get-involved" element={Public(<GetInvolved />)} />
            <Route path="/support" element={Public(<Support />)} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
